export default "__VITE_ASSET__DVOKfUmt__"